import { Bot, TrendingUp, Shield, Zap } from "lucide-react";

export function Benefits() {
  const benefits = [
    {
      icon: Bot,
      title: "Automation",
      description: "AI-powered workflows that eliminate manual processes"
    },
    {
      icon: Shield,
      title: "Transparency",
      description: "Complete visibility across all procurement operations"
    },
    {
      icon: TrendingUp,
      title: "ROI Uplift",
      description: "Measurable improvements in operational efficiency"
    },
    {
      icon: Zap,
      title: "SAP/CRM Integration",
      description: "Seamless connection with existing enterprise systems"
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="mb-6 text-3xl lg:text-4xl font-bold">What is NexProcureAI?</h2>
          <p className="mb-12 text-lg text-muted-foreground">
            NexProcureAI is an intelligent procurement and scheme management platform that leverages AI to streamline operations, enhance transparency, and drive measurable ROI improvements for modern retail enterprises.
          </p>
        </div>
        
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          {benefits.map((benefit, index) => (
            <div key={index} className="text-center">
              <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full" style={{ backgroundColor: '#FF814C' }}>
                <benefit.icon className="h-8 w-8 text-white" />
              </div>
              <h3 className="mb-2 font-bold">{benefit.title}</h3>
              <p className="text-sm text-muted-foreground">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}